<template>
  <div class="speedmapContainer">
    <div class="text-left">
      <h4 style="display: inline" class="platformSpeedmapText">Barrier</h4>
      <h4 style="display: inline; float: right" class="text-right platformSpeedmapText">Lead</h4>
    </div>
    <v-progress-linear
      :color="checkBookie(bookie)"
      height="10"
      rounded
      class="mb-3"
    ></v-progress-linear>
    <div
      v-for="d in sortByBarrier(detailedRace.competitors)"
      :key="d.tabNo"
      style="margin-bottom: 5px"
    >
      <PlatformSpeedMap :runner="d" :race="detailedRace" />
      <div v-if="!d.scratched" style="height: 25px"></div>
    </div>
  </div>
</template>

<script>
import PlatformSpeedMap from './PlatformSpeedMap'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'SingleSpeedMap',
  components: {
    PlatformSpeedMap
  },
  created () {
    this.setStoreVariables()
    this.fetchSpeedMap()
    this.getUrlParam()
    const bodyCSS = document.querySelector('body')
    bodyCSS.style.background = 'none'
    bodyCSS.style.maxWidth = 'none'
    bodyCSS.style.minWidth = '0px'

    const setVis = this.setClientVisibility
    window.addEventListener('message', function (event) {
      const eventData = event?.data

      if (eventData === 'FrameHeight') {
        const boxInterval = setInterval(() => {
          const box = document.querySelector('.speedmapContainer')
          if (box !== null) {
            clearInterval(boxInterval)
            event.source.postMessage({ FrameHeight: box.clientHeight }, '*')
            setVis('open') // this is for backward compatibility if parent window isn't sending 'open'|'close' events
          }
        }, 100)
      } else if (['open', 'close'].includes(eventData)) {
        setVis(eventData)
      }
    })

    if (window.parent === window.top) setVis('open') // not in iframe set clientVisibilityOpen
  },
  props: {
  },
  data () {
    return {
      cssPath: process.env.BASE_URL + 'stylesheets/' + window.location.host.split('.')[0] + '.css'
    }
  },
  methods: {
    ...mapActions(['setRouterVariables', 'fetchSpeedMap', 'setClientVisibility']),
    sortByBarrier (competitors) {
      return competitors.slice().sort((a, b) => b.barrier - a.barrier)
    },
    setStoreVariables () {
      const varObj = {
        gbsID: this.$route.params.id,
        raceNo: this.$route.params.raceNo,
        runnerNo: this.$route.params.runnerNo
      }
      this.setRouterVariables(varObj)
    },
    getUrlParam () {
      const file = document.createElement('link')
      file.rel = 'stylesheet'
      file.href = this.cssPath
      document.head.appendChild(file)
    },
    checkBookie (bookie) {
      switch (bookie) {
        case 'topsport':
          return 'light-blue'
        case 'betmakers':
          return 'pink'
        case 'uat':
          return 'pink'
        case 'neds':
          return 'orange'
        case 'do':
          return 'blue'
        case 'robwaterhouse':
          return 'purple'
        case 'realbookie':
          return 'cyan'
        case 'picnicbet':
          return 'blue darken-3'
        case 'bbet':
          return 'blue'
        case 'betdeluxe':
          return 'red'
        case 'crossbet':
          return 'cyan'
        case 'texbet':
          return 'green'
        case 'zbet':
          return 'blue'
        case 'nztab':
          return 'blue'
        case 'mailbag':
          return 'orange'
        case 'dimers':
          return 'blue'
        case 'pronet':
          return 'blue'
        case 'sportsbetting':
          return 'orange'
        case 'wishbet':
          return 'orange'
        case 'caymanasbet':
          return 'green'
      }
    }
  },
  computed: {
    ...mapState(['detailedRace', 'bookie'])
  }
}
</script>

<style scoped>

</style>
